import { createAction, createReducer } from 'redux-act';
import { getUserSubscriptions } from 'src/services/news';

import { IPublicUser } from '@sravni/types/lib/auth';

import { SravniIdentityClientsSubscriptionInfo } from '../__generated__/news/Api';
import { App } from '../types';

type UserSubscriptions = {
  subscription: {
    list: SravniIdentityClientsSubscriptionInfo['types'];
    subscribing: boolean;
    didUserSubscribe: boolean;
    isSubscriptionPopupVisible: boolean;
  };
};

export type IState = UserSubscriptions &
  (
    | {
        loggedIn: true;
        account: IPublicUser;
        fingerprint: string;
      }
    | { loggedIn: false; fingerprint: string }
  );

const DEFAULT_SUBSCRIPTION = {
  list: null,
  subscribing: false,
  didUserSubscribe: false,
  isSubscriptionPopupVisible: false,
};

const initialState: IState = {
  loggedIn: false,
  subscription: DEFAULT_SUBSCRIPTION,
  fingerprint: '-1',
};

export const setUser = createAction<IPublicUser>('users/set');
export const destroyUser = createAction('users/destroy');
export const setUserSubscriptions = createAction<SravniIdentityClientsSubscriptionInfo['types']>(
  'user/set-from-identity',
);

export const setDidUserSubscribe = createAction<boolean>('user/subscription/status');
export const setSubscribing = createAction<boolean>('user/subscription-posting');
export const setSubscriptionPopupVisibility = createAction<boolean>('user/subscription-popup-visibility');
export const setFingerprint = createAction<string>('user/set/fingerprint');

export default createReducer<IState>({}, initialState)
  .on(setUser, (state, payload) => ({
    ...state,
    loggedIn: true,
    account: payload,
  }))
  .on(destroyUser, (state) => ({
    loggedIn: false,
    subscription: DEFAULT_SUBSCRIPTION,
    fingerprint: state.fingerprint,
  }))
  .on(setUserSubscriptions, (state, payload) => ({
    ...state,
    subscription: {
      ...state.subscription,
      list: payload,
    },
  }))
  .on(setSubscribing, (state, payload) => ({
    ...state,
    subscription: {
      ...state.subscription,
      subscribing: payload,
    },
  }))
  .on(setSubscriptionPopupVisibility, (state, payload) => ({
    ...state,
    subscription: {
      ...state.subscription,
      isSubscriptionPopupVisible: payload,
    },
  }))
  .on(setFingerprint, (state, payload) => ({
    ...state,
    fingerprint: payload,
  }))
  .on(setDidUserSubscribe, (state, payload) => ({
    ...state,
    subscription: {
      ...state.subscription,
      didUserSubscribe: payload,
    },
  }));

export const fetchUserSubscriptions = (): App.ReduxAction => {
  return async (dispatch) => {
    try {
      const subscriptions = await getUserSubscriptions();
      dispatch(setUserSubscriptions(subscriptions));
    } catch (error) {}
  };
};
